export default __webpack_public_path__ + "static/media/printerFeeder.c775250b.png";